import React, { ReactElement } from 'react';
import { SiteMember } from '../ChatCreation';
import styles from './MemberList.scss';
import { AVATARS } from '../../../constants/avatars';
import MemberEntry from './MemberEntry/MemberEntry';
import utils from '../../../services/utils';
import { connect } from 'react-redux';
import { primaryColorOrDefault } from '../../../reducers';
import Waypoint from 'react-waypoint';
import classNames from 'classnames';

interface MemberListProps {
  primaryColor: string;
  members: SiteMember[];
  onSelect?(id: string): any;
  onFetchMore?(): any;
  entrySuffix?(id: string): ReactElement | undefined;
  badges?(id: string): (ReactElement | string)[] | undefined;
  isMemberListForPrivateChat?: boolean;
}

const mapStateToProps = (state) => ({
  primaryColor: primaryColorOrDefault(state),
});

export const MemberList = connect(mapStateToProps)(
  class extends React.Component<MemberListProps> {
    renderMember = ({ userId, name, image }: SiteMember) => {
      const { onSelect, primaryColor, entrySuffix, badges } = this.props;

      const avatar =
        image && image.url
          ? { ...AVATARS.IMG.prop, imgUrl: image.url }
          : AVATARS.NONE.prop;

      return (
        <div
          key={userId}
          style={{
            background: `${utils.getRgbA(primaryColor, 0.1)}`,
          }}
        >
          <MemberEntry
            key={userId}
            id={userId}
            name={name}
            avatar={avatar}
            onSelect={onSelect}
            entrySuffix={entrySuffix && entrySuffix(userId)}
            badges={badges && badges(userId)}
          />
        </div>
      );
    };

    render() {
      return (
        <div
          className={classNames(styles.memberList, {
            [styles.memberListForPrivate]: this.props
              .isMemberListForPrivateChat,
          })}
        >
          {this.props.members.map(this.renderMember)}
          <Waypoint
            key={`fetch-more-members-waypoint-${this.props.members.length}`}
            onEnter={this.props.onFetchMore}
          />
        </div>
      );
    }
  },
);
